<script>
	export let value = "";
	export let maxlength = 1000;
	export let error = false;
	export let errorText = "";
	export let placeholder = "";
</script>

<div>
	<textarea
		{placeholder}
		bind:value
		{maxlength}
		class="getgo form-control textarea input"
		rows="3"
	/>
	<p class="d-flex justify-content-end word-count">
		{value.length + `/` + maxlength} characters
	</p>
	{#if error}
		<small class="error-text">{errorText}</small>
	{/if}
</div>

<style>
	.textarea {
		width: 100%;
		height: 140px !important;
	}

	.word-count {
		color: var(--fds-on-surface-variant);
		font-size: 12px;
	}
</style>
